import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CustomerNavbar from './CustomerNavbar';
import CaregiverNavbar from './CaregiverNavbar';
import MobileFooter from './MobileFooter';
import BackgroundPattern from './BackgroundPattern';

const MainLayout: React.FC = () => {
  const { user } = useAuth();
  const userType = user?.userType;

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans relative">
      <BackgroundPattern />
      <div className="relative z-10 flex flex-col min-h-screen">
        {userType === 'customer' ? <CustomerNavbar /> : userType === 'caregiver' ? <CaregiverNavbar /> : null}
        
        <main className="flex-grow w-full">
          <Outlet />
        </main>
        
        {userType && <MobileFooter userType={userType} />}
      </div>
    </div>
  );
};

export default MainLayout;
